export interface PrioridadeSolicitacao {
  id: number
  nome: string
  descricao: string
}

class PrioridadeSolicitacaoImpl implements PrioridadeSolicitacao {
  constructor(public readonly id: number, public readonly nome: string, public readonly descricao: string) {}
}

export class Prioridades {
  public static readonly NORMAL: PrioridadeSolicitacao = new PrioridadeSolicitacaoImpl(1, "Normal", "Merece atenção no curto prazo")
  public static readonly ALTA: PrioridadeSolicitacao = new PrioridadeSolicitacaoImpl(2, "Alta", "Demanda de grande impacto no fluxo de trabalho")
  public static readonly IMEDIATA: PrioridadeSolicitacao = new PrioridadeSolicitacaoImpl(3, "Imediata", "Necessidade de ação imediata")


  public static asArray() {
    return [
      this.NORMAL,
      this.ALTA,
      this.IMEDIATA,
    ]
  }

  private static prioridadesById = Object.fromEntries(Prioridades.asArray().map(x => [x.id, x]))

  public static byId(id: number) {
    return Prioridades.prioridadesById[id];
  }
}

